export default __webpack_public_path__ + "static/media/tokenBadgeGold108@2x.4ecddc47.png";